import { render, staticRenderFns } from "./productEditChecklist.vue?vue&type=template&id=0f6d9f8f&scoped=true&"
import script from "./productEditChecklist.vue?vue&type=script&lang=js&"
export * from "./productEditChecklist.vue?vue&type=script&lang=js&"
import style0 from "./productEditChecklist.vue?vue&type=style&index=0&id=0f6d9f8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6d9f8f",
  null
  
)

export default component.exports